'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box from '@components/kit/box'
import Button from '@components/kit/button'
import Loading from '@components/kit/loading'
import Modal from '@components/kit/modal'
import Text from '@components/kit/text'

// lib
import { IMemberOpportunity } from '@store/MemberOpportunities'
import { getOpportunityTypeStyle } from './data/taxonomy'

/* -----------------------------------------------------------------------------
 * RejectOpportunityModal
 * -------------------------------------------------------------------------- */

type RejectOpportunityModalProps = {
  error: string | null
  isSubmitting: boolean
  onCancel: () => void
  onConfirm: () => void
  opportunity: IMemberOpportunity | null
}

function RejectOpportunityModal({
  error,
  isSubmitting,
  onCancel,
  onConfirm,
  opportunity
}: RejectOpportunityModalProps) {
  return (
    <Modal
      open={opportunity !== null}
      onRequestClose={onCancel}
      showCloseButton={false}
      maxWidth={440}
    >
      {opportunity ? (
        <>
          <Text font='pro.text.16.semibold' textColor='proInk'>
            Reject this opportunity?
          </Text>
          <Text font='pro.text.13.regular' mt='08' textColor='proTextBody'>
            {`${getOpportunityTypeStyle(opportunity.opportunity_type).label} for ${opportunity.drug_name ?? 'this medication'}, member ${opportunity.user_id}. It leaves this list and nothing reaches the member.`}
          </Text>
          {error ? (
            <Text font='pro.text.13.medium' mt='12' textColor='proDangerDeep'>
              {error}
            </Text>
          ) : null}
          {isSubmitting ? <Loading my='16' /> : null}
          <Box flexDirection='row' gap='12' justifyContent='flex-end' mt='24'>
            <Button variant='tertiary' disabled={isSubmitting} onPress={onCancel}>
              Cancel
            </Button>
            <Button
              variant='secondary'
              disabled={isSubmitting}
              onPress={onConfirm}
            >
              Reject
            </Button>
          </Box>
        </>
      ) : null}
    </Modal>
  )
}

export default RejectOpportunityModal
